import React from 'react'
import PropTypes from 'prop-types'
import { Edit } from '@material-ui/icons'
import { Button } from 'ui-components/Button'
import { DescItemList } from 'ui-components/DescItemList'
import { DescList } from 'ui-components/DescList'
import { Container } from './styles'

export default function SalesChannel({ salesChannel, onClick }) {
  const handleClick = () => {
    onClick(salesChannel)
  }

  return (
    <DescList>
      <Container>
        <DescItemList label="Nome">
          {salesChannel.attributes.name}
        </DescItemList>
        <Button buttonType="icon" onClick={handleClick}>
          <Edit />
        </Button>
      </Container>
    </DescList>
  )
}

SalesChannel.propTypes = {
  salesChannel: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired,
}
